


import React, { createContext, useContext, useEffect, useState } from "react";
import {
  List,
  Button,
  Typography,
  Tooltip,
  message,
  notification,
  Badge,
  Popconfirm,
  Skeleton,
  Select,
  Form,
  Radio
} from "antd";

import "../../style/commercialobligationsettings.css";
import { Dialog, DialogFooter } from "@fluentui/react/lib/Dialog";
import { TextField } from "@fluentui/react/lib/TextField";
import {
  PrimaryButton,
  DefaultButton,
} from "@fluentui/react/lib/Button";
import * as yup from "yup";
import { observer } from "mobx-react";
import { Formik } from "formik";
import { Scrollbars } from "react-custom-scrollbars";
import FormItem from "antd/lib/form/FormItem";
import { Spinner, SpinnerSize } from "@fluentui/react";

import { MessageBar, MessageBarType } from "@fluentui/react";
import WrfmSettingStore from "../../store/wrfmsettingstore";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { getCurrentUser } from "../../../../Utility/modules/helpers";
import { HelpCircle } from "react-feather";
const { Title } = Typography;

const { Option } = Select;
const wrfmStoreCtx = createContext(WrfmSettingStore);
export const Fields = observer((props) => {
    const [status, setStatus] = useState("Active");
  const wrfmStore = useContext(wrfmStoreCtx);
  
  const permissionStore = {};
  const [state, setState] = useState({
    hideDialog: true,
    action: "add",
    selRow: {},
  });

  useEffect(() => {
    async function loadFields() {
      try {
        await wrfmStore.loadFields();
      } catch (error) {
        notification.error({
          message: "Feedback Manager",

          description: `Something went wrong.${error.message}.`,
        });
      }
    }
    loadFields();
  }, []);

  const _closeDialog = () => {
    setState({ hideDialog: true });
  };
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const field = { ...values, uploadedBy: getCurrentUser().fullName,status:status };

      console.log(field);
      const retVal = await wrfmStore.createField(field);
      wrfmStore.fields.set(retVal.fieldId, retVal);
if(state.action==='edit'){
  message.success(`${field.fieldName} field modified successfully`);
}else{
  message.success(`${field.fieldName} field created successfully`);
}
    
        setSubmitting(false);
      setState({ hideDialog: true }); 
    } catch (error) {
      
      notification.open({
        message: "Feedback Manager",
        type: "error",

        description: `${error.response.text}.`,
      });
      setSubmitting(false);
    }
  };
  return (
    <div
      className="ms-Grid"
      dir="ltr"
      style={{ borderRight: "1px solid #F0F2F5", marginRight: "5px" }}
    >
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          {" "}
          <Scrollbars style={{ height: "100vh", overflowX: "hidden" }}>
            {wrfmStore.isLoading ? (
              <>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
              </>
            ) : (
              <List
                itemLayout="horizontal"
                dataSource={[...wrfmStore.fields.values()]}
                size="small"
                style={{ width: "95%" }}
                header={
                  <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm10">
                        {" "}
                        <Title
                          level={4}
                          style={{
                            display: "inline-block",
                            marginRight: "5px",
                            fontSize: "16px",
                            color: "red",
                          }}
                        >
                          Fields 
                        </Title>
                        <Badge count={wrfmStore.fields.size} />
                      </div>
                      <div
                        className="ms-Grid-col ms-sm2"
                        style={{
                          textAlign: "right",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Tooltip title="Add  New Field">
                          <Button
                            shape="circle"
                            icon={<PlusOutlined />}
                            type="primary"
                            onClick={(ev) => {
                              setState({
                                hideDialog: false,
                                action: "add",
                                header: `Create New  Field`,
                                selRow: {},
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                    <div className="ms-Grid-row" style={{ paddingTop: "10px" }}>
                      <div className="ms-Grid-col ms-sm12">
                        <MessageBar messageBarType={MessageBarType.warning}>
                          click  edit or delete  to modify field name,status or remove field
                        </MessageBar>
                      </div>
                    </div>
                  </div>
                }
                renderItem={(item) => (
                  <List.Item
                    actions={[
                      <Tooltip
                        title={`modify ${item?.fieldName} field`}
                      >
                        <Button
                          type="link"
                          icon={<EditOutlined />}
                         
                          style={{ fontSize: "18px" }}
                          onClick={() => {
                            setState({
                              action: `edit`,
                              header: `Change ${item?.fieldName.toUpperCase()} field attribute`,
                              hideDialog: false,
                              selRow: item,
                            });
                            setStatus(item?.status)
                          }}
                        />
                      </Tooltip>,
                      <Tooltip
                        title={`Delete ${item?.fieldName.toUpperCase()} field`}
                      >
                        <Popconfirm
                          title={`Are you sure you want to remove ${item?.fieldName} field?`}
                          okText="Yes"
                          cancelText="No"
                          onConfirm={() => {
                            try {
                              permissionStore.removePriviledge(item);
                              message.success(
                                `${item.name} field removal was successfull`
                              );
                            } catch (error) {
                              message.error(
                                `something went wrong  due to : ${error.message} `
                              );
                            }
                          }}
                        >
                          <Button
                            type="link"
                            disabled
                            icon={<DeleteOutlined />}
                            style={{ fontSize: "18px" }}
                          />
                        </Popconfirm>
                      </Tooltip>,
                      <Tooltip
                        title={
                          <div className="ms-Grid" dir="ltr">
                            {" "}
                            <div className="ms-Grid-row">
                              <div className="ms-Grid-col ms-sm12">audit</div>
                            </div>
                            <div className="ms-Grid-row">
                              <div className="ms-Grid-col ms-4">created by</div>{" "}
                              <div className="ms-Grid-col ms-8">
                                {item?.uploadedBy}
                              </div>
                            </div>
                            <div className="ms-Grid-row">
                              <div className="ms-Grid-col ms-sm12">
                                {item?.uploadedOn}
                              </div>
                            </div>
                          </div>
                        }
                      >
                        <Button type="link" icon={<HelpCircle />} size={16} />
                      </Tooltip>,
                    ]}
                  >
                    <List.Item.Meta
                      title={<span>{item.fieldName}</span>}
                      description={item.status}
                    />
                  </List.Item>
                )}
              />
            )}
          </Scrollbars>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <Dialog
            hidden={state.hideDialog}
            onDismiss={_closeDialog}
            dialogContentProps={{
              title: state.header,
              subText: "Enter name and description for the field.",
            }}
            modalProps={{
              isBlocking: false,
              styles: { main: { maxWidth: 450 } },
              dragOptions: true,
            }}
          >
            <Formik
              initialValues={state.selRow}
              onSubmit={(values, { setSubmitting }) => {
                handleSubmit(values, { setSubmitting });
              }}
              validationSchema={yup.object().shape({
                fieldName: yup
                  .string()
                  .required("field Name is required"),
               
              })}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => {
                return (
                  <Form onFinish={handleSubmit} layout="vertical">
                    <div className="ms-Grid" dir="ltr">
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                          <TextField
                            label="Field Name "
                            required
                            name="fieldName"
                            value={values?.fieldName}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            errorMessage={
                              touched.fieldName && errors.fieldName
                            }
                          />
                        </div>
                      </div>{" "}
                       <FormItem label="Status" >
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
 <Radio.Group
                           size='small'
            buttonStyle="solid" 
            value={values?.status}
            onChange={({ target }) => {
              setStatus(target.value);
              setFieldValue('status',target.value)
            }}
          >
            <Radio.Button value="Active">Active</Radio.Button>
            <Radio.Button value="InActive">InActive</Radio.Button>
           
          </Radio.Group>
                          
                          
                        </div>
                      </div>
                      </FormItem>
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                          <FormItem label="Description">
                            <TextField
                              multiline
                              rows={5}
                              name="remarks"
                              value={values?.remarks}
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                          </FormItem>
                        </div>
                      </div>
                      <div
                        className="ms-Grid-row"
                        style={{ marginTop: "10px" }}
                      >
                        <div className="ms-Grid-col ms-sm12">
                          {isSubmitting && (
                            <Spinner
                              label="saving field record,please wait..."
                              ariaLive="assertive"
                              labelPosition="right"
                              size={SpinnerSize.large}
                            />
                          )}
                        </div>
                      </div>
                      <DialogFooter>
                        <PrimaryButton text="Save" type="submit" />
                        <DefaultButton onClick={_closeDialog} text="Cancel" />
                      </DialogFooter>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Dialog>
        </div>
      </div>
    </div>
  );
});

